function openGroup(evt, groupName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(groupName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  document.getElementById("defaultOpen").click();

  $(".tabsButton").click(function(){
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  });

  $("#prev01").click(function(){
    $("#color").show();
    $("#defaultOpen").addClass("active");
  });
  $("#prev02").click(function(){
    $("#text").show();
    $("#tabText").addClass("active");
  });
  $("#prev03").click(function(){
    $("#icon").show();
    $("#tabIcon").addClass("active");
  });
  $("#prev04").click(function(){
    $("#sharpen").show();
    $("#tabSharpen").addClass("active");
  });
  $("#Next01").click(function(){
    $("#text").show();
    $("#tabText").addClass("active");
  });
  $("#Next02").click(function(){
    $("#icon").show();
    $("#tabIcon").addClass("active");
  });
  $("#Next03").click(function(){
    $("#sharpen").show();
    $("#tabSharpen").addClass("active");
  });
  $("#Next04").click(function(){
    $("#order").show();
    $("#tabOrder").addClass("active");
  });
  $(".productoptionswatch").click(function(){
      var parentClass =  "." + $(this).parent().parent().prop('className') + " .productoptionswatch.clicked";
      var labelparentClass =  "." + $(this).parent().parent().prop('className') + " label.productoptionswatchwrapper.clicked";
      console.log(parentClass);
      if (parentClass == ". .productoptionswatch.clicked"){
        parentClass = ".productoptionswatch.clicked"
      }
      $(parentClass).removeClass("clicked");
      $(labelparentClass).removeClass("clicked");
      $(this).addClass("clicked");
      $(this).parent().addClass("clicked");
  });
  $(".themascot .productoptionswatch").click(function(){
      var parentClass =  "." + $(this).parent().parent().prop('className') + " .productoptionswatch.clicked";
      var labelparentClass =  "." + $(this).parent().parent().prop('className') + " label.productoptionswatchwrapper.clicked";
      var parentClassInput =  "." + $(this).parent().parent().prop('className') + " .productoptionswatchwrapper.clicked .doogma-chooseyourmascot";
      var inputValue = $(parentClassInput).attr("value");
      var inputlabel = $(this).parent().children('.swatchtooltip').text();
    
      console.log(parentClassInput);
      console.log(inputValue);
      if (inputValue != "none"){
        $(".doogma-mascotadded").val(true);
      }
      else {
        $(".doogma-mascotadded").val(false);
      }
      
      $(".WhichMascot").val(inputlabel);
  });
  $(".ImprintColor .productoptionswatch").click(function(){
      var inputlabel = $(this).parent().children('.swatchtooltip').text();
      $(".WhichColor").val(inputlabel);
  });

  var input = document.getElementById('js-qty-custom');
  var increment = 144;

  $("span.js-qty__adjust.js-qty__adjust--minus.quantity__minus").click(function(){
    console.log('minus' + $('#js-qty-custom').val());
    var valueminus = $('#js-qty-custom').val() - increment;
    if (valueminus > 432){
      $('#js-qty-custom').val(valueminus);
    }
    else {
      $('#js-qty-custom').val(432);
    }
    setTimeout(function(){
        if (valueminus < 432){
          $('#js-qty-custom').val(432);
        }
    }, 300);

  });
  $("span.js-qty__adjust.js-qty__adjust--plus.quantity__plus").click(function(){

    var valueplus = $('#js-qty-custom').val()* 1;
    valueplus = valueplus+increment;
    console.log(valueplus);
    $('#js-qty-custom').val(valueplus);
  });
  $("#yesSharpen").click(function(){
    $("#SingleOptionSelector-0").val("Yes").change();
  });
  $("#noSharpen").click(function(){
    $("#SingleOptionSelector-0").val("No").change();
  });
  var box = document.getElementById('doogma-addimprinttext');
  var charlimit = 32; // char limit per line
  box.onkeyup = function() {
  	var lines = box.value.split('\n');
  	for (var i = 0; i < lines.length; i++) {
  		if (lines[i].length <= charlimit) continue;
  		var j = 0; space = charlimit;
  		while (j++ <= charlimit) {
  			if (lines[i].charAt(j) === ' ') space = j;
  		}
  		lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
  		lines[i] = lines[i].substring(0, space);
  	}
  	box.value = lines.slice(0, 3).join('\n');
  };
$( document ).ready(function() {
    if(window.matchMedia("(max-width: 767px)").matches){
    console.log("*****StartSticky");
      stickyElem = document.querySelector(".ImageContainerSticky");

      currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset;
      window.onscroll = function() {

          /* Check if the current Y offset
          is greater than the position of
          the element */
          if(window.pageYOffset > currStickyPos) {
              stickyElem.style.position = "fixed";
              stickyElem.style.top = "0px";
          } else {
              stickyElem.style.position = "relative";
              stickyElem.style.top = "initial";
          }
      }
    }
    window.onresize = function() {
      if(window.matchMedia("(max-width: 600px)").matches){
        console.log("*****StartSticky");
          stickyElem = document.querySelector(".ImageContainerSticky");

          currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset;
          window.onscroll = function() {

              /* Check if the current Y offset
              is greater than the position of
              the element */
              if(window.pageYOffset > currStickyPos) {
                  stickyElem.style.position = "fixed";
                  stickyElem.style.top = "0px";
                $("#contentContainer").css('margin-top',360);
              } else {
                  stickyElem.style.position = "relative";
                  stickyElem.style.top = "initial";
                $("#contentContainer").css('margin-top',0);
              }
          }
        }
      else {
        stickyElem = document.querySelector(".ImageContainerSticky");
        stickyElem.style.position = "relative";
        stickyElem.style.top = "initial";
      }

    }
  setTimeout(function(){
      $("input[value='red']").click();
      $("input[value='ffffff']").click();
      $("input[value='ffffff']").parent().addClass("clicked");
      $("input[value='red']").parent().addClass("clicked");
      var inputlabel = $("input[value='ffffff']").parent().children('.swatchtooltip').text(); 
      $(".WhichColor").val(inputlabel);
    }, 1500);
});
document.querySelectorAll("#doogma-addimprinttext03").forEach(function(inputItem){
  inputItem.addEventListener("keyup", function(event){
    if(event.target.value.length < 1){
      $(".doogma-thirdlineadded").val('n');
      
    }else{
      $(".doogma-thirdlineadded").val('y');
    }
  });
});
document.querySelectorAll("#doogma-addimprinttext01").forEach(function(inputItem){
  inputItem.addEventListener("keyup", function(event){
    if(event.target.value.length < 1){
      $(".doogma-secondlineadded").val('n');
      
    }else{
      $(".doogma-secondlineadded").val('y');
    }
  });
});